

/**
 * @export
 * @class CQAppConstant
 */
// const ENV_VARIABLE =  process.env;
export class CQAppConstant {

    public static INTERVAL_THRESHOLD = 10000; // 10 seconds
    public static POLLING_MAX_INTERVAL = 600000; // 10 minutes
    public static WAIT_FOR_RUN_INITIAL_INTERVAL_MS = 3000; // 3 seconds
    public static WAIT_FOR_RUN_MAX_ATTEMPTS = 20;
    public static ORG_LIST_PAGE_SIZE = 20;
    public static TAG_MAX_LENGTH = 50;
    public static TAG_MAX_COUNT = 10;

    public static TIME_CONSTANTS = {
        MS_IN_SECOND: 1000,
        SECONDS_IN_MINUTE: 60,
        SECONDS_IN_HOUR: 60 * 60,
        SECONDS_IN_DAY: 24 * 60 * 60
    } as const;

    //Localhost and Proxy server details
    public static LOCAL_HOST_NAME = 'localhost:8080';
    public static LOCAL_SERVER = 'http://localhost:8088';
    
    //Services and API details
    public static PROXY_SERVICE = '/proxy';
    public static ZIP_SERVICE = '/zip';
    public static DOCUMENT_SERVICE = '/cqdoc';
    public static USER_INFO = '/userInfo';
    public static EXECUTE_QUERY = '/executeQuery';
    public static INITIALIZE = '/initialize';
    public static TOOLING_QUERY = '/toolingQuery'
    public static EXECUTE_TASK = '/executeTask';
    public static CHECK_AUTH = '/checkAuth';
    public static MANAGED_PACKAGE_VERSION = '/managed-package-version';
    public static OAUTH_START = '/oauth2/start';
    public static LOGOUT = '/logout';
    public static STATUS = '/status';
    public static PUSH_PORTAL_SERVICE = '/push-portal';
    public static API_VERSION_NUMBER = '64.0';
    public static NS_CORE_PKG = 'compliancequest';
    public static NS_EXT_PKG = 'cqext';
    public static CQCOLLAB = 'cqcollab';
    public static SSOT = 'ssot'
    public static CQ_DOC_EXT_APP = 'CQ Document Extensions App';
    public static CQ_DOC_EXT_APP_GOVT = 'CQ Document Extensions App Govt. Cloud';
    public static SALESFORCE_STANDARD_DATA_MODEL = 'Salesforce Standard Data Model'
    public static CQ_SUPPLIER_CENTRAL_EXT = 'CQ Supplier Central Extension';
    public static CQ_CONFIG_UI_EXT = 'CQ Config UI Extension';
    public static COMPLIANCEQUEST = 'ComplianceQuest';
    public static DA_INFO_COPYRIGHT = '© ComplianceQuest';
    // List of release note URLs by min version. getReleaseNotesUrl() finds the highest one the version meets.
    // The 0.0.0 entry is the legacy catch-all for any version below the first real entry.
    public static RELEASE_NOTES: { minVersion: string; url: string }[] = [
        { minVersion: '0.0.0', url: 'https://compliancequest.atlassian.net/servicedesk/customer/portal/1/article/117179224' },
        { minVersion: '16.0.0', url: 'https://help.compliancequest.com/summer-2026-help/cq-summer-2026' },
    ];
    public static DEPLOYMENT_STATUS_PATH ="/lightning/setup/DeployStatus/home";
    public static MIGRATION_REPORT_DASHBOARD_PATH = "/lightning/n/CQ_Migration_Dashboard";
    public static MIGRATION_REPORT_VIEW_PATH = "/lightning/r/Report/{id}/view";
    public static MIGRATION_LOGS_REPORT_DEVELOPER_NAME = "CQ_Migration_Logs_Report";
    public static MIGRATION_LOGS_REPORT_FOLDER_NAME = "CQ Migration Logs Report";
    public static NOT_AVAILABLE = "N/A";
    public static DATE_PART_DAY = "day";
    public static DATE_PART_MONTH = "month";
    public static DATE_PART_YEAR = "year";

    public static CQ_NAMESPACES: readonly string[] = [
        CQAppConstant.NS_CORE_PKG,
        CQAppConstant.NS_EXT_PKG
    ] as const;

    public static CQ_NON_NAMESPACE_PKGS = [
        { name: CQAppConstant.CQ_DOC_EXT_APP, namespace: CQAppConstant.CQCOLLAB },
        { name: CQAppConstant.CQ_DOC_EXT_APP_GOVT, namespace: CQAppConstant.CQCOLLAB },
        { name: CQAppConstant.SALESFORCE_STANDARD_DATA_MODEL, namespace: CQAppConstant.SSOT },
        { name: CQAppConstant.CQ_SUPPLIER_CENTRAL_EXT, namespace: '' },
        { name: CQAppConstant.CQ_CONFIG_UI_EXT, namespace: '' },
    ] as const;
    
    public static ORG_NAME = "ORG_NAME";
    public static INSTALLED_PACKAGES = "INSTALLED_PACKAGES";
    public static FETCH_PROFILES = "FETCH_PROFILES";
    public static FETCH_PROFILE_DETAILS = "FETCH_PROFILE_DETAILS";
    public static UNKNOWN_ORG = 'Unknown Organization';
    public static NO_PACKAGE = 'No package';
    public static ORG_TYPE = {
        SANDBOX: 'Sandbox',
        PRODUCTION: 'Production',
        SCRATCH: 'Scratch'
    };

    public static ENV_KEYWORDS = {
        STAGING: 'staging',
        SANDBOX: 'sandbox'
    } as const;

    public static AUTH_STATUS = {
        AUTHENTICATED: 'AUTHENTICATED',
        UNAUTHENTICATED: 'UNAUTHENTICATED',
        EXPIRED: 'EXPIRED'
    };

    public static AUTH_STATUS_BADGE_CLASSES = {
        AUTHENTICATED: 'slds-badge slds-theme_success',
        UNAUTHENTICATED: 'slds-badge',
        EXPIRED: 'slds-badge slds-theme_error'
    };

    public static DEPLOYMENT_STATUS_BADGE_CLASSES = {
        SUCCESS: 'slds-badge slds-theme_success',
        FAILED: 'slds-badge slds-theme_error',
        IN_PROGRESS: 'slds-badge slds-theme_warning',
        PENDING: 'slds-badge',
        SCHEDULED: 'slds-badge slds-theme_default',
        PAUSED: 'slds-badge slds-theme_info'
    };

    public static UPGRADE_STATUS = {
        SUCCESS: 'SUCCESS',
        FAILED: 'FAILED',
        IN_PROGRESS: 'IN_PROGRESS',
        PENDING: 'PENDING',
        SCHEDULED: 'SCHEDULED',
        PAUSED: 'PAUSED'
    } as const;

    public static BULK_SCHEDULE_STEPS = {
        SELECT_ORGS: 'select-orgs',
        SELECT_UPGRADE: 'select-upgrade'
    };

    public static UNSYNCED_VERSION = '__unsynced__';

    // Filter modes for Push Portal
    public static FILTER_MODE = {
        UPDATE: 'update' as const,
        UPGRADE: 'upgrade' as const,
        ALL: 'all' as const
    };

    // Activity tabs for Push Portal
    public static ACTIVITY_TAB = {
        PAUSED: 'paused' as const,
        PENDING: 'pending' as const,
        FAILED: 'failed' as const,
        SCHEDULED: 'scheduled' as const
    };

    // Toast/Alert variants
    public static ALERT_VARIANT = {
        SUCCESS: 'success' as const,
        ERROR: 'error' as const,
        WARNING: 'warning' as const
    };

    // Push Portal pagination and UI settings
    public static PUSH_PORTAL_UI = {
        ACTIVITY_PAGE_SIZE: 5,
        DEBOUNCE_TIMEOUT: 300,
        DROPDOWN_LENGTH: 5,
        PLACEHOLDER_TEXT: '—',
        RESET: 'reset' as const,
        NEXT: 'next' as const,
        PREV: 'prev' as const,
        ROW_ACTIONS: {
            ABORT: 'abort' as const,
            DELETE: 'delete' as const
        },
        IDS: {
            SCHEDULED_ACTIVITY_TABLE: 'scheduled-activity-table',
            PAUSED_ACTIVITY_TABLE: 'paused-activity-table',
            PENDING_ACTIVITY_TABLE: 'pending-activity-table',
            FAILED_ACTIVITY_TABLE: 'failed-activity-table',
            UPGRADE_ACTIVITY_TABS: 'upgrade-activity-tabs',
            FILTER_MODE_UPDATE: 'filter-mode-update',
            FILTER_MODE_UPGRADE: 'filter-mode-upgrade',
            FILTER_VERSION: 'filter-version',
            FILTER_ORG_TYPE: 'filter-org-type',
            FILTER_ORG_SEARCH: 'filter-org-search',
            OAUTH_LOGINURL: 'oauth-loginurl'
        },
        COLUMN_KEYS: {
            ROW_ACTIONS: 'rowActions'
        },
        TEXT: {
            SYNC_FAILED: 'Sync failed',
            ORG_ID_LABEL: 'Org ID',
            ORG_TYPE_LABEL: 'Org Type',
            REGISTERED_ADMIN_USERNAME_LABEL: 'Registered Admin Username',
            REGISTERED_BY_LABEL: 'Registered By',
            RELEASE_LABEL: 'Release',
            LAST_UPGRADE_STATUS_LABEL:'Last Upgrade Status',
            LAST_UPGRADED_TIME_LABEL:'Last Upgraded Time',
            AUTH_STATUS_LABEL:'Auth Status', 
            TAGS_LABEL: 'Tags:',
            INSTALLED_PACKAGES_LABEL: 'Installed Packages'
        },
        ENDPOINTS: {
            ABORT_ACTIVITY: '/activity/abort'
        },
        PUSH_REQUEST_STATUSES: {
            SCHEDULED: 'SCHEDULED' as const,
            PROCESSING: 'PROCESSING' as const,
            FAILED: 'FAILED' as const,
            CANCELLED: 'CANCELLED' as const,
            COMPLETED: 'COMPLETED' as const,
            PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED' as const,
        },
        // Reflects the run time configured in the Heroku scheduler, used only for DA to handle scheduling accordingly.
        // Changing this value will not cause upgrades to actually run at that time.
        SCHEDULER_RUN_UTC: {
            HOUR: 3, // 3 AM UTC
            MINUTE: 30, // 30 minutes past the hour
            DISPLAY: '03:30 UTC',
        },
        // Strict YYYY-MM-DD format, used to validate date-picker input before building a scheduledTime.
        DATE_ONLY_REGEX: /^\d{4}-\d{2}-\d{2}$/,
    };

    // Default Salesforce URLs
    public static DEFAULT_URLS = {
        SF_LOGIN: 'https://login.salesforce.com',
        SF_TEST: 'https://test.salesforce.com'
    };

    public static SF_MANAGED_PKG_INSTALL_PATH = '/packaging/installPackage.apexp';
    public static SF_MANAGED_PKG_INSTALL_QUERY_PARAM = 'p0';

    public static MIGRATION_LOGIN = {
        MODE: 'migration',
        QUERY_KEYS: {
            STATUS: 'migrationLogin',
            USERNAME: 'migrationUsername',
            LOGIN_URL: 'migrationLoginUrl',
            MESSAGE: 'message',
            LOGIN_URL_PARAM: 'loginUrl',
            RETURN_URL: 'returnUrl'
        },
        SESSION_KEYS: {
            RETURN_URL: 'cqMigrationReturnUrl'
        },
        STATUS: {
            SUCCESS: 'success',
            ERROR: 'error',
            PENDING: 'pending'
        },
        TIMEOUTS: {
            CLOSE_SUCCESS_MS: 1200,
            CLOSE_ERROR_MS: 3000
        }
    } as const;

    public static REQUEST_HEADERS = {
        X_INSTANCE_TOKEN: 'x-instance-token',
        X_INSTANCE_URL: 'x-instance-url',
        X_VERSION: 'x-version',
        X_CURRENT_ORG_ID: 'x-current-org-id'  
    }


    public static CQ_ERROR_TYPES_TEXT = 'CQ_ERROR_TYPES';
    public static ERROR_GENERIC = 'ERROR_GENERIC';
    public static ERROR_FATAL = 'ERROR_FATAL';
    public static ERROR_SERVER = 'ERROR_SERVER';
    public static ERROR_CUSTOM = 'ERROR_CUSTOM';
    public static ERROR_SESSION = 'ERROR_SESSION_EXPIRED';
    public static DEPLOY_FAILED = 'ERROR_DEPLOY_FAILED';
    public static UNKNOWN_PUBLISH_ERROR = 'UNKNOWN_PUBLISH_ERROR';
    public static BASE_CLASS_ALREADY_EXIST_WARNING = 'BASE CLASS ALREADY EXIST';
    public static COMPONENT_NAME_ALREADY_EXIST_WARNING = 'COMPONENT NAME ALREADY EXIST';
    public static SAME_BASE_CLASS_ERROR = 'SAME BASE CLASS ERROR';

    public static CQ_ERROR_TYPES = [
        CQAppConstant.ERROR_GENERIC,
        CQAppConstant.ERROR_FATAL,
        CQAppConstant.ERROR_SERVER,
        CQAppConstant.ERROR_CUSTOM,
        CQAppConstant.ERROR_SESSION,
        CQAppConstant.DEPLOY_FAILED,
        CQAppConstant.UNKNOWN_PUBLISH_ERROR,
        CQAppConstant.BASE_CLASS_ALREADY_EXIST_WARNING,
        CQAppConstant.COMPONENT_NAME_ALREADY_EXIST_WARNING,
        CQAppConstant.SAME_BASE_CLASS_ERROR
    ];

    public static COMPONENT_ACTION_TYPES = [
        'LIGHTNING_COMPONENT',
        'VF_PAGE'
    ];

    public static API_RESPONSE_CODES = {
        UNAUTHORIZED: 401,
        SUCCESS: 200,
        BAD_REQUEST: 400,
        FORBIDDEN_REQUEST: 403,
        INTERNAL_SERVER_ERROR: 500
    };

    public static NBA_TYPES = {
        URL: 'url',
        NOTIFICATION:'notification',
        QUICK_ACTION:'QuickAction'
    };

    public static NBA_PREFIX = {
        URL_PREFIX:'cqui_nba_url_',
        NOTIFICATION_PREFIX:'cqui_nba_msg_'
    };

    public static ERROR_MESSAGES = {
        SESSION_EXPIRED: 'Your session has expired. Please log in again to continue.',
        UNKNOWN_ERROR: 'An unknown error occurred.',
        PACKAGE_DEPLOYMENT_FAILURE: 'Package deployment failed. Please check the deployment status.',
        CORS_ERROR_MESSAGE: 'CORS error occurred. Please check your network settings.',
        BASE_CLASS_ALREADY_EXIST_WARNING_MESSAGE: 'Base class already exists. Please choose a different name.',
        COMPONENT_NAME_ALREADY_EXIST_WARNING_MESSAGE: 'Component name already exists. Please choose a different name.',
        SAME_BASE_CLASS_ERROR_MESSAGE: 'Base class and component name cannot be the same.',
        MIGRATION_FAIL_ERROR: 'Migration failed. Please try again.',
        OAUTH_FAILED: 'Failed to initiate OAuth flow',
        MISSING_CODE_STATE: 'Missing OAuth code or state parameter.',
        NO_USER: 'Could not resolve current user for org registration. Please refresh and try again.',
        EXCHANGE_FAILED: 'OAuth exchange failed',
        SELECT_AT_LEAST_ONE_ORG: 'Select at least one org',
        CONTACT_ADMINISTRATOR: 'Please contact your administrator.'
    };

    public static ERROR_TABLE_EXCLUDED_KEYS = new Set(['changed', 'created', 'deleted', 'success', 'attributes']);

    public static HTTP_REQUEST_TYPES = {
        GET_REQUEST: 'GET',
        POST_REQUEST: 'POST',
        DELETE_REQUEST: 'DELETE',
    };

    public static LOADING_TEXT_DEFAULT = 'Fetching Data';

    public static JWT_KEY = 'jwtToken';
    public static INSTANCE_URL = 'instanceUrl';
    public static VERSION_NUMBER = 'versionNumber';
    public static LOGGED_IN_USERNAME = 'username';
    public static LOGGED_IN_ORG_NAME_SPACE = 'orgNameSpace';
    public static LOGGED_IN_ORG_ID = 'orgID';
    public static LOGIN_URL = 'loginUrl';
    public static MIGRATION_USERNAME_KEY = 'migrationUsername';
    public static MIGRATION_LOGIN_URL_KEY = 'migrationLoginUrl';
    public static MIGRATION_USER_KEY = 'migrationUser';
    public static LOG_OUT = 'Log Out';
    public static SANDBOX_ENV = 'test';
    public static PRODUCTION_ENV = 'prod';
    public static SANDBOX_LOGINURL = 'https://test.salesforce.com';
    public static SANDBOX_LOGIN_DOMAIN = 'test.salesforce.com';
    public static PRODUCTION_LOGINURL = 'https://login.salesforce.com';

    public static OAUTH_QUERY_PARAMS = {
        LOGIN_URL: 'loginUrl',
        RETURN_TO: 'returnTo'
    };

    public static NAVIGATION = {
        DEFAULT_PATH: '/',
        LOGIN: '/login',
        AUTH_SUCCESS_CALLBACK: '/authSuccessCallback',
        OTHER_ORG_AUTH_SUCCESS_CALLBACK: '/authOtherOrgSuccessCallback',
        TEMPLATES: '/templates',
        TEMPLATES_CONFIGURATION: '/templateConfiguration',
    };

    public static TEMPLATE_CONFIG_TABS = {
        COMPONENT_CONFIG_TAB: 'Component Level Config',
        LAYOUT_CONFIG_TAB: 'Layout level config',
        GRID_CONFIG_TAB: 'Grid Level Config',
    };

    public static CQ_DOCUMENT_LOG = {
        ACTIVE_TASK: "activeTask",
        CQ_TASKS: "cq-tasks",
    }

    public static CQ = {
        HISTORY: 'cq-installed-packages-history',
        UPDATES: 'cq-installed-packages-history-updates',
        UPGRADES: 'cq-installed-packages-history-upgrades',
        REFRESH: 'cq-installed-packages-history-refresh',
        FRESH: 'cq-installed-packages-history-fresh',
        INSTALLATION_LOG_DOCUMENT: 'cqInstallationLogDocument',
        DOCUMENT: 'cqDocument'
    };

    public static CQNBA ='cqNBA';
    public static DEFAULT_COMPONENT_NAME_SPACE ='c';
    public static ACTION_OVERRIDE = 'actionOverride';
    public static ICON_NAME = 'iconName';
    public static ACTION_OVERRIDE_DROPDOWN = ['Create', 'Edit', 'None'];
    public static NONE = 'None';
    public static CLASS_NAME = 'className';
    public static COMPONENT_TYPE = 'componentType';
    public static COMPONENT_TYPE_FLOW = 'Flow';
    public static COMPONENT_TYPE_ESIG_ONLY = 'Esig Only';
    public static COMPONENT_TYPE_LIGHTNING_COMPONENT = 'Lightning Component';
    public static COMPONENT_TYPE_FORM = 'Form';
    public static ESIG = 'esig';
    public static BOOLEAN = 'boolean'
    public static DOWNLOAD = 'Download';
    public static PUBLISH = 'Publish';
    public static DOWNLOADABLE_ZIP_FILE_NAME = 'src.zip';
    public static AND_OPERATOR = 'AND';
    public static OR_OPERATOR = 'OR';
    public static ADD_COMPLEX_LOGIC = 'Add Complex logic';
    public static PICKLIST = 'Picklist';
    public static COMPLEX_LOGIC_QUERY = 'complexLogicQuery';
    public static CONFIRM_MESSAGE_LAYOUT_CHANGE = 'Warning: Changing layout or object will reset the rules defined in the editor. Do you want to continue?';
    public static CONFIRM_MESSAGE_OBJECT_CHANGE = 'Warning: Changing object will reset the rules defined in the editor. Do you want to continue?';
    public static INFO_MESSAGE_SF_LAYOUT_EDITOR = 'Please close the SF layout editor page to resume configuring form.';
    public static SF_LAYOUT_EDIT_URL = '{{baseURL}}/lightning/setup/ObjectManager/{{objectId}}/PageLayouts/{{layoutId}}/view';
    public static POST_REFRESH = 'Post Refresh Actions';


    public static ADDITIONAL_FIELDS_ACTIONS = {
        ADD: 'add',
        UPDATE: 'update',
        DELETE: 'delete',
    };

    public static LOGICAL_OPERATORS = {
        AND: '&&',
        OR: '||'
    };

    public static FIELD_API_NAMES = ['ContentWorkspace', 'Calendar']

    public static CQ_RECORD_RULES_TYPES = {
        hidden: { key: 'hidden', label: 'Hide field'},
        readonly: { key: 'readonly', label: 'Make field read-only'},
        required: { key: 'required', label: 'Make field required'},
        redirectTo: { key: 'redirectTo', label: 'Set filter and query for redirection'},
        visible: { key: 'visible', label: 'Show field'},
        lookupFilter: { key: 'lookupFilter', label: 'Lookup Filter'},
        dynamicSource: { key: 'dynamicSource', label: 'Get lookup options from apex'},
        formulaFieldHyperlink: { key: 'Formula Field - Hyperlink', label: 'Evaluate formula'},
        formulaFieldImage: { key: 'Formula Field - Image', label: 'Evaluate formula'},
        transfer: { key: 'transfer', label: 'Transfer parent field value to field'},
        setValues: { key: 'setValues', label: 'Set the value of a particular field'},
        invoke: { key: 'invoke', label: 'Invoke a flow that modifies field value'},
        conditionallyVisible: { key: 'true', label: 'Conditionally Visible' },
        hide: { key: 'false', label: 'Hide' }
    };

    public static OBJECT_NAME = 'objectName';
    public static LOOKUP_FILTERS = 'lookupFilter';
    public static DYNAMIC_SOURCE = 'dynamicSource';
    public static TRANSFER_RULE = 'transfer';

    public static TOGGLE_ACTION_RULES = [
        'hidden',
        'readonly',
        'visible',
        'required',
    ];

    public static COMPONENT_EVENT_RULES_MAP :any = {
        afterSaveRedirectTo: { key: 'afterSave-redirectTo', label: '' },
        onInitInvoke: { key: 'onInit-invoke', label: '' },
        onLoadInvoke: { key: 'onLoad-invoke', label: '' },
        onLoadsetValues: { key: 'onLoad-setValues', label: '' },
        onLoadtransfer: { key: 'onLoad-transfer', label: '' }
    };

    public static LAYOUT_EVENT_RULES :any = {
        afterSave: { key: 'afterSave', label: 'After saving redirect to' },
        onInit: { key: 'onInit', label: 'When creating a new record'},
        onLoad: { key: 'onLoad', label: 'When page loads' }
    };

    public static LAYOUT_EVENT_SUB_RULE = {
        afterSave: [
            'redirectTo'
        ],
        onInit: [
            'invoke'
        ],
        onLoad: [
            'invoke',
            'setValues',
            'transfer'
        ]
    };

    public static TOGGLE_ACTION_RULE_TYPES = [
        'hidden',
        'readonly',
        'visible',
        'required',
    ];

    public static CUSTOM_ADDED_FIELD =['isRecordOwner', "userInfo.Id", "isNewRecord","customSettings"];

    public static TRANSFER_RULE_TYPE = 'transfer';
    public static ACTION = 'action';

    public static ADDED_CRITERIAS = 'addedCriterias';
    public static ISVISIBLE = 'isVisible';
    public static LOOKUP_FILTER = 'filters';
    public static LOOKUP_FILTER_SELECTED_REFERENCE_FIELDS = 'selectedReferenceFields';
    public static SET_OBJECTS = 'setObject';
    public static SET_VALUES = 'setValues';
    public static COMPLEX_LOGIC = 'complexLogic';
    public static ADD_TRIGERRING_FIELDS = 'Add triggering fields';
    public static TRIGERRING_FIELD = 'Triggering field';
    public static PARENT_FIELD_VALUE = '.value';
    public static DEFAULT_PARENT_FIELDS = ['Id' , 'Name'];

    public static PUBLISH_STATUS_URL = '/lightning/setup/DeployStatus/home';


    public static INPUT_RULE_OPERATORS = [
        {
            label: 'Exists',
            value: 'Exists'
        },
        {
            label: 'Is Empty',
            value: 'IsEmpty'
        },
        {
            label: 'Equal to',
            value: '=='
        },
        {
            label: 'Not Equal to',
            value: '!='
        },
        {
            label: 'Greater than equal to',
            value: '>='
        },
        {
            label: 'Greater than',
            value: '>'
        },
        {
            label: 'Less than Equal to',
            value: '<='
        },
        {
            label: 'Less than',
            value: '<'
        }
    ];   
    public static EXISTS = 'Exists';
    public static ISEMPTY = 'IsEmpty';
    public static RECORD = 'record.';
    public static PARENT = 'parent.';

    public static LOOKUP_TEXT = 'Lookup';
    public static MASTERDETAIL_TEXT = 'MasterDetail';
    public static REFERENCE_FIELD_TYPE = ['Lookup','MasterDetail'];

    public static LOOKFILTER_CONDITION_OPERATORS = [
        {
            label: 'All Conditions Are Met',
            value: 'and'
        },
        {
            label: 'Any Condition Is Met',
            value: 'or'
        }
    ];

    public static LOOKFILTER_FIELD_OPERATORS = [
        {
            label: 'eq',
            value: 'eq'
        },
        {
            label: 'neq',
            value: 'neq'
        },
        {
            label: 'lt',
            value: 'lt'
        },
        {
            label: 'lte',
            value: 'lte'
        },
        {
            label: 'gt',
            value: 'gt'
        },
        {
            label: 'gte',
            value: 'gte'
        },
        {
            label: 'endswith',
            value: 'endswith'
        },
        {
            label: 'startswith',
            value: 'startswith'
        },
        {
            label: 'contains',
            value: 'contains'
        }
    ];

    public static GRID_AND_CLAUSE = [
        {
            label: 'eq',
            value: '='
        },
        {
            label: 'neq',
            value: '!='
        },
        {
            label: 'lt',
            value: '<'
        },
        {
            label: 'lte',
            value: '<='
        },
        {
            label: 'gt',
            value: '>'
        },
        {
            label: 'like',
            value: 'LIKE'
        },
        {
            label: 'in',
            value: 'IN'
        },
        {
            label: 'not-in',
            value: 'NOT IN'
        }
    ];

    public static LOOKUPFILTER_STATIC_VALUE_TYPE_MAP = [
        {
            type: 'string', keyValue: 's_value'
        },
        {
            type: 'integer', keyValue: 'i_value'
        },
        {
            type: 'double', keyValue: 'd_value'
        },
        {
            type: 'boolean', keyValue: 'b_value'
        },
        {
            type: 'date', keyValue: 'dt_value'
        },
        {
            type: 'datetime', keyValue: 'dtt_value'
        },
        {
            type: 'reference', keyValue: 'usv_param'
        }
    ];

    public static SETVALUE_RULE_DYNAMIC_SOURCE_VALUES = [
        {
            label: 'Clear value',
            value: null,
            isSupportedFunction: false
        },
        {
            label: 'AddDays()',
            value: 'addDays',
            isSupportedFunction: true
        },
        {
            label: 'setCurrentUser()',
            value: 'setCurrentUser',
            isSupportedFunction: true
        }
    ];

    public static RULE_TYPES_OBJECT: any = {
        LOOKUP: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'lookupFilter',
            'dynamicSource',
            'transfer',
            'setValues',
            'invoke'
        ],
        TEXT: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'setValues',
            'invoke'
        ],
        PICKLIST: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'setValues',
            'invoke'
        ],
        FORMULA_FIELD: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'formulaFieldHyperlink',
            'formulaFieldImage'
        ],
        MASTERDETAIL: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'lookupFilter',
            'dynamicSource',
            'transfer',
            'setValues',
            'invoke'
        ],
        DEFAULT: [
            'hidden',
            'readonly',
            'visible',
            'required',
            'setValues',
            'invoke'
        ],
        QUICKACTION:[
            'visible'
        ],
        URL:[
            'visible'
        ],
        NOTIFICATION:[
            'visible'
        ],
        HEADERACTION: [
            'conditionallyVisible',
            'hide'
        ],
        ROWACTION: [
            'conditionallyVisible',
            'hide'
        ],
        CUSTOMCOMPONENTACTION: [
            'conditionallyVisible'
        ]
    };

    public static ACTION_TYPES = [
        'standard_header_action',
        'custom_header_action',
        'standard_row_action',
        'custom_row_action'
    ];

    public static ORDER_SUBSCRIBER_PACKAGE_NAME = 'ORDER BY SubscriberPackage.Name ASC'
    public static GET_SUBSCRIBER_PACKAGE_ID = 'WHERE SubscriberPackageVersionId = ({0})'
    public static GET_SUBSCRIBER_PACKAGE_VERSION='WHERE Id = ({0})'

    public static QUERIES = {
        layouts :   `SELECT Name,LayoutType,ManageableState,NamespacePrefix,EntityDefinition.DeveloperName, EntityDefinition.NamespacePrefix FROM Layout
                    WHERE EntityDefinition.IsActivityTrackable = true AND LayoutType = 'Standard'`,
        flows:  `SELECT VersionNumber, ApiName FROM FlowDefinitionView WHERE NamespacePrefix = Null AND ApiName In ({0}) `,
        customObject: `SELECT Id FROM CustomObject WHERE DeveloperName IN ({0})`,
        objectLayouts: `SELECT Name,LayoutType,ManageableState,NamespacePrefix,EntityDefinition.DeveloperName, EntityDefinition.NamespacePrefix FROM Layout WHERE TableEnumOrId IN ({0})`,
        quickAction: `SELECT Label, DeveloperName, NamespacePrefix, SobjectType, Type FROM QuickActionDefinition WHERE NamespacePrefix ='${CQAppConstant.NS_EXT_PKG}' AND SobjectType IN ({0})`,
        flexipage : `SELECT DeveloperName, NamespacePrefix, EntityDefinition.DeveloperName, EntityDefinition.NamespacePrefix from FlexiPage where ManageableState = 'unmanaged'`,
        lightningBundle : `Select DeveloperName from lightningComponentBundle where ManageableState = 'installed' AND NamespacePrefix = '${CQAppConstant.NS_EXT_PKG}'`,
        auraBundle : `Select DeveloperName from AuraDefinitionBundle where ManageableState = 'installed' AND  NamespacePrefix = '${CQAppConstant.NS_EXT_PKG}'`,
        installedPackages : `SELECT SubscriberPackageId, MinPackageVersionId, SubscriberPackageVersionId, SubscriberPackage.Name, SubscriberPackage.IsPackageValid, SubscriberPackage.NamespacePrefix,
                    SubscriberPackageVersion.MajorVersion, SubscriberPackageVersion.MinorVersion, SubscriberPackageVersion.PatchVersion, SubscriberPackageVersion.Name FROM InstalledSubscriberPackage ({0})`,
        staticResource : `SELECT Id, NamespacePrefix, Name FROM StaticResource WHERE ( Name ='({0})SetupData_PostActions')`,
        profileLayout : `SELECT Profile.Name FROM ProfileLayout where Layout.Name='({0})'`,
        versionDetails: `SELECT Id, MajorVersion, MinorVersion, PatchVersion FROM SubscriberPackageVersion ({0})` ,
        document: "SELECT Id, FolderId, Url, Description, Keywords, Body FROM Document WHERE Folder.DeveloperName = 'Compliance_Quest' AND Name = 'CQInstallationLog' ORDER BY LastModifiedDate DESC",
        migrationLogsReport: `SELECT Id FROM Report WHERE DeveloperName = '${CQAppConstant.MIGRATION_LOGS_REPORT_DEVELOPER_NAME}' AND FolderName = '${CQAppConstant.MIGRATION_LOGS_REPORT_FOLDER_NAME}' LIMIT 1`
    };
    
    public static UPGRADETYPE = {
        DEFAULT : 'mixed',
        DEPRECATED:  'deprecate-only'
    };

    public static UPGRADED_TYPES = {
        UPDATES: "updated",
        UPGRADES: "upgraded",
        REFRESH: "refreshed",
        FRESH: "installed"
    };

    public static MODULE_TYPES = {
        UPDATE: "Update",
        UPGRADE: "Upgrade",
        UPDATES: "Updates",
        UPGRADES: "Upgrades",
        REFRESH: "Refresh",
        REFRESHES: "Refreshes",
        FRESH: "Fresh"
    };

    public static APPLICABLE_FRESH_INSTALLS_KEY = 'applicableFreshInstalls';

    public static SHARED_MIGRATION = {
        SCRIPT_NAME: 'Shared Migration Script',
        DISPLAY_NAME: "Migration Execution",
        VERSION_NAME_PREFIX: 'Upgrade to '
    };
    
    // module tabs labels
    // Note: Both UPGRADES and UPGRADE_PLUS exist for different purposes:
    // - UPGRADES: Used as fallback for process/display labels in progress UI
    // - UPGRADE_PLUS: Used as the actual tab name for the combined upgrades+fresh installation tab
    public static MODULE_TABS = {
        UPDATES: "Updates",
        UPGRADES: "Upgrades",
        UPGRADE_PLUS: "Upgrade+",
        REFRESH: "Post Refresh",
        FRESH: "Fresh"
    };
    
    /**
     * Installation status enumeration for tracking the lifecycle of installations.
     * @readonly
     * @property {string} CREATED - Indicates that an installation has been created but not yet submitted.
     * @property {string} SUBMITTED - Indicates that an installation has been submitted for processing.
     */
    public static INSTALLATION_STATUSES = {
        CREATED: 'CREATED',
        SUBMITTED: 'SUBMITTED',
        COMPLETED: 'COMPLETED',
        FAILED: 'FAILED'
    };

    public static TASK_STATUS_LABELS = {
        COMPLETED: 'Completed',
        PENDING: 'Pending',
        FAILED: 'Failed',
        NOT_STARTED: 'Not started'
    };

    /**
     * Column definitions for migration v2 subtasks table.
     * Used in CQMigrationSubtasksV2 component to display migration script details.
     * @property {string} key - Unique identifier for the column
     * @property {string} label - Display label for the column header
     */
    public static MIGRATION_V2_COLUMNS = [
        { key: 'objectName', label: 'Object Name' },
        { key: 'objectApiName', label: 'Object API Name' },
        { key: 'migrationScript', label: 'Migration Script' },
        { key: 'status', label: 'Status' },
        { key: 'toProcess', label: 'To Process' },
        { key: 'completed', label: 'Completed' },
        { key: 'failed', label: 'Failed' }
    ];

    public static MIGRATION_V2_PANEL_IDS = {
        PRE_MIGRATION: 'pre-migration',
        MIGRATION_SCRIPTS: 'migration-scripts',
        POST_MIGRATION: 'post-migration'
    } as const;

    public static MIGRATION_V2_PROPERTY_NAMES = {
        STATUS: 'status',
        OBJECT: 'object',
        UNKNOWN: 'unknown'
    } as const;

    public static TAB_LABELS = {
        PENDING: 'Pending',
        SCHEDULED: 'Scheduled',
        FAILED: 'Failed',
        PAUSED: 'Paused'
    };

    public static BUTTON_LABELS = {
        CONTINUE: 'Continue',
        CANCEL: 'Cancel',
        CLOSE: 'Close',
        CONNECT: 'Connect',
        CONNECTING: 'Connecting…',
        CONFIRM: 'Confirm'
    };

   public static ACTIVE_STATUSES = {
        CREATED: 'CREATED',
        SUBMITTED: 'SUBMITTED',
        IN_PROGRESS: 'IN_PROGRESS'
   }

    public static TASK_TYPES={
        MIGRATION_TASK_TYPE : 'SFMigrationTask',
        MIGRATION_TASK_TYPE_V2 : 'CQMigrationTaskV2',
        SF_DEPLOY_PACKAGES : "SFDeployPackages"
    }

    public static JSON_SCHEMA_TASK_TYPES={
        MIGRATION_TASK_TYPE_V2 : 'cqMigrationTaskV2'
    }

     public static DATA_TYPES ={
        STRING: 'string',
        UNDEFINED: 'undefined'
    } as const

    // Task status icon names
    public static TASK_ICON_NAMES = {
        CLOSE: 'close',
        CHECK: 'check',
        RECORD: 'record'
    } as const;

    // Task status color variants
    public static TASK_COLOR_VARIANTS = {
        SUCCESS: 'success',
        ERROR: 'error',
        LIGHT: 'light'
    } as const;

     // Visual style of modal prompt
    public static PROMPT_STYLE = {
        SUCCESS: 'success',
        WARNING: 'warning',
        ERROR: 'error',
        WRENCH: 'wrench',
        OFFLINE: 'offline',
        INFO: 'info'
    } as const;

    // Button style for the confirm action 
    public static CONFIRM_ACTION_STYLE = {
        BRAND: 'brand',
        DESTRUCTIVE: 'destructive',
        NEUTRAL: 'neutral',
        WARNING: 'warning'
    } as const;

    // Supported modal sizes
    public static MODAL_SIZE = {
        SMALL: 'small',
        MEDIUM: 'medium',
        LARGE: 'large',
        COMPACT: 'compact' // Maps to no SLDS size class at all, which yields the genuinely smallest modal.
    } as const;
}